import { LABELS } from '~/resources/Labels';
import { FormScriptResponse } from '~/models/Commons ';
import { SIMPLDialog } from '../../components/commons/dialog/SimplDialog';
import SIMPLFile from '../../components/commons/input/SIMPLFile';
import { useDropzone } from 'react-dropzone';
import { SIMPLButtonCustomized } from '../../components/commons/button/SIMPLButtonCustumized';
import { useFormConfigFile } from './UseFormConfigFile';
import { LoadingWrapper } from '../../components/commons/spiner/SimpleLoaderWrapper';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Prop {
  onCloseModal: () => void;
  editedItem: FormScriptResponse | null;
  item: FormScriptResponse;
  setConfig: Function;
  refetch: () => void;
   onSuccess?: (title: string, message: string, response: any) => void,
  onError?: (title: string, message: string) => void
}

const labelClass = 'font-semibold max-w-[300px]';
 const ConfigFile = ({
  onCloseModal,
  editedItem,
  setConfig,
  refetch,
  item,
    onSuccess,    
    onError
}: Prop) => {
  const { handleSubmit, errors, control, onConfigDrop, submitForm,isLoading,isError} =
    useFormConfigFile(
      editedItem,
      onCloseModal,
      refetch,
      item.scriptIdentify.deploymentScriptId,
      onSuccess,
      onError
    );
const { t } = useTranslation();
  // Second Dropzone for configFiles (accepts only YAML)
  const {
    getRootProps: getConfigRootProps,
    getInputProps: getConfigInputProps,
    isDragActive: isConfigDragActive,
  } = useDropzone({
    onDrop: onConfigDrop,
    maxFiles: 1,
    accept: {
      'application/x-yaml': ['.yml', '.yaml'],
    },
  });
  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    handleSubmit(submitForm)(event);
    setConfig({
      key: '',
      direction: LABELS.ASC,
    });
  };

  const renderButtons = () => (
    <>
      {!isLoading&&<div className="grow-0 basis-32 mr-5">
        <SIMPLButtonCustomized
          label={t("Cancel")}
          secondary
          buttonHandlerAction={onCloseModal}
          testId='configFile-button-cancel'
        />
      </div>}
     {!isLoading && <div className="grow-0 basis-32">
        <SIMPLButtonCustomized
          label={t("Submit")}
          primary
          testId='configFile-button-submit'
        />
      </div>}
    </>
  );

  return (
    <SIMPLDialog
      onCloseModal={onCloseModal}
      title={t("ConfigFiles")}
      actions={renderButtons()}
      onSubmit={handleFormSubmit}
      showLine
    >
       <LoadingWrapper
          loadingTitle="Loading Scripts..."
          isLoading={isLoading}
          isError={isError}
          testId='configFile-loading'
        >
      <div className="w-auto pb-3 flex flex-col">
        <div className="flex flex-row mt-3 p-3">
          <div className="flex-1">
            <div className={labelClass}>{t("Title")}</div>
            <div className={""}>{item.title}</div>
          </div>
        </div>
        <div className="flex flex-row mt-3 p-3">
          {item.cloudEnvironment?.cloudProvider?.cloudProviderName &&<div className="flex-1">
            <div className={labelClass}>{t("CloudProvider")}</div>
            <div className={""}>{item.cloudEnvironment?.cloudProvider?.cloudProviderName}</div>
          </div>}
        </div>
        <div className="flex flex-row mt-3 pb-2">
          <div className="flex-1 truncate p-3">
             <Controller
                name="configFiles"
                control={control}
                rules={{ required: t('ConfigFilesRequired') }}
                render={({ field }) => (
                  <SIMPLFile
                    onFileChange={field.onChange}
                    required={false}
                    errorFieldName="configFiles"
                    errors={errors}
                    currentScript={
                      field.value instanceof File ? field.value : null
                    }
                    LABELS={LABELS}
                    labelName={t("ConfigFiles")}
                     dragDropFileHereLabel={t('DragDropFileHereOrClickHere')}
                    chooseFileLabel={t('ChooseFile')}
                    getRootProps={getConfigRootProps}
                    getInputProps={getConfigInputProps}
                    isDragActive={isConfigDragActive}
                    testId='configFile-file'
                  />
                )}
              />
          </div>
        </div>
        <div className="flex flex-row mt-3">
          <div className="flex-1 truncate p-3">
            <div className={labelClass}>{t("ConfigFilesList") }</div>
            <div style={{ overflowY: 'scroll', maxHeight: '200px' }}>
              {item.configFiles.length > 0 ? (
                <ul>
                  {item.configFiles.map((configFile, index) => (
                    <li
                      key={configFile.fileName || index}
                      className={""}
                    >
                      {configFile.fileName}
                    </li>
                  ))}
                </ul>
              ) : (
                <div className={""}>{t("NoConfigFilesAvailable")}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </LoadingWrapper>  
    </SIMPLDialog>
  );
};
export default ConfigFile;